// extracted by mini-css-extract-plugin
export default {"SupplierCount":"SupplierCount_SupplierCount__3SEuh"};